import React, { createContext, PropsWithChildren } from 'react';
import classNames from 'classnames';

import './index.scss';

type CheckboxGroupInterface = Partial<{
  value: string;
  onChange: (value: string) => void;
  className?: string;
}>;

export const CheckboxGroupContext = createContext<CheckboxGroupInterface | null>(null);

const CheckboxGroup: React.FC<PropsWithChildren<CheckboxGroupInterface>> = props => {
  const { children, value, className, onChange } = props;

  return (
    <CheckboxGroupContext.Provider value={{ value, onChange }}>
      <div className={classNames(className, 'my-radio')}>{children}</div>
    </CheckboxGroupContext.Provider>
  );
};

export default CheckboxGroup;
